import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminReset() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw1 !== pw2) return setError("Las contraseñas no coinciden");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw1 });
      setDone(true);
      setTimeout(() => navigate("/admin/login"), 2500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-reset-page" className="min-h-screen bg-[#0F1115] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="block text-center font-serif text-3xl text-[#FDFBF7]">
          Luz de <span className="italic text-[#D5C0A1]">Cádiz</span>
        </Link>
        <p className="text-center text-[10px] uppercase tracking-[0.3em] text-[#A0A3A9] mt-3 mb-10">Nueva contraseña</p>

        {done ? (
          <div data-testid="reset-done" className="bg-[#181A1F] border border-[#2A2D35] p-8 text-center">
            <p className="text-sm text-[#9DC4A8]">Contraseña actualizada. Te llevo al acceso…</p>
          </div>
        ) : (
          <form data-testid="admin-reset-form" onSubmit={submit} className="bg-[#181A1F] border border-[#2A2D35] p-8 flex flex-col gap-6">
            {!token && <p className="text-xs text-[#E08A6C]">Enlace no válido. Pide uno nuevo desde el acceso.</p>}
            <input
              data-testid="reset-pw1"
              type="password"
              required
              minLength={8}
              placeholder="Nueva contraseña (mín. 8 caracteres)"
              value={pw1}
              onChange={(e) => setPw1(e.target.value)}
              className="bg-transparent border-b border-[#2A2D35] focus:border-[#D5C0A1] outline-none py-3 text-sm text-[#FDFBF7] placeholder:text-[#A0A3A9]/60 transition-colors"
            />
            <input
              data-testid="reset-pw2"
              type="password"
              required
              minLength={8}
              placeholder="Repite la contraseña"
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="bg-transparent border-b border-[#2A2D35] focus:border-[#D5C0A1] outline-none py-3 text-sm text-[#FDFBF7] placeholder:text-[#A0A3A9]/60 transition-colors"
            />
            {error && <p data-testid="reset-error" className="text-xs text-[#E08A6C]">{error}</p>}
            <button
              data-testid="reset-submit"
              type="submit"
              disabled={loading || !token}
              className="py-3.5 bg-[#D5C0A1] text-[#0F1115] text-xs uppercase tracking-[0.25em] hover:bg-[#FDFBF7] transition-colors disabled:opacity-50"
            >
              {loading ? "…" : "Guardar contraseña"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
